import { render, staticRenderFns } from "./PdpBuildABundleCta.vue?vue&type=template&id=222a1316&scoped=true&"
import script from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
export * from "./PdpBuildABundleCta.vue?vue&type=script&lang=js&"
import style0 from "./PdpBuildABundleCta.vue?vue&type=style&index=0&id=222a1316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a1316",
  null
  
)

export default component.exports